import React from 'react';
import { Phone, Star } from 'lucide-react';
import { EmergencyQuoteForm } from '../../components/EmergencyQuoteForm/EmergencyQuoteForm';
function HeroStarRow() {
  return <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-929">
      {[0, 1, 2, 3, 4].map(i => <Star key={i} className="w-3.5 h-3.5 text-amber-500 fill-amber-500" data-id="element-930" />)}
    </span>;
}
export function HeroQuotePanel() {
  return <div className="lg:col-span-5 w-full" id="quote-form" data-id="element-931">
      <div className="bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden" data-id="element-932">
        <div className="p-6 sm:p-8" data-id="element-933">
          <div className="inline-block bg-emergencyBrand-red text-white px-3 py-1.5 text-xs font-bold uppercase tracking-wider mb-5 rounded" data-id="element-934">
            Urgent Auto Glass Quote
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-935">
            Request Emergency Auto Glass Help
          </h2>
          <p className="text-sm text-slate-600 leading-relaxed mb-6" data-id="element-936">
            Submit your details and a Kosin's Glass team member will contact you
            to confirm your vehicle, glass type, damage, insurance information,
            location and today's availability.
          </p>

          <EmergencyQuoteForm onSubmit={e => e.preventDefault()} data-id="element-937" />

          <div className="mt-6 pt-5 border-t border-slate-100 text-center" data-id="element-938">
            <p className="text-sm text-slate-600" data-id="element-939">
              Prefer to call?{' '}
              <a href="tel:517-545-7772" className="inline-flex items-center gap-1.5 text-slate-900 font-bold hover:text-emergencyBrand-red" data-id="element-940">
                <Phone className="w-4 h-4 text-emergencyBrand-red" data-id="element-941" />
                517-545-7772
              </a>
            </p>
            <p className="text-xs text-slate-400 mt-2" data-id="element-942">
              We respect your privacy. Your details are safe with us.
            </p>
          </div>
          {/* Micro-testimonial */}
          <div className="mt-5 pt-5 border-t border-slate-100" data-id="element-943">
            <div className="flex items-center gap-2 mb-2" data-id="element-944">
              <HeroStarRow data-id="element-945" />
              <span className="sr-only" data-id="element-946">5-star review.</span>
              <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-947">
                Verified Customer
              </span>
            </div>
            <p className="text-sm italic text-slate-600 leading-relaxed" data-id="element-948">
              "[Paste short real customer review here.]"
            </p>
            <p className="text-xs text-slate-500 mt-1.5" data-id="element-949">
              — [Customer name], [City]
            </p>
          </div>
        </div>
      </div>
    </div>;
}